var o={color:"{form.field.icon.color}"},r={icon:o};export{r as default,o as icon};//# sourceMappingURL=index.mjs.map